<template>
    <div
        v-if="showPaginate"
        class="flex flex-col lg:flex-row items-center"
        :class="[hideTotals ? 'justify-center' : 'justify-between']"
    >
        <div
            v-if="!hideTotals"
            class="text-black"
            v-html="$t('general.pagination.showing', { from: data.meta.from, to: data.meta.to, total: data.meta.total})">
        </div>

        <nav
            aria-label="Pagination"
            class="z-0 inline-flex items-center space-x-6"
        >
            <button
                :class="[!hasPrevious ? 'text-primary-60 pointer-events-none' : 'text-black cursor-pointer']"
                class="flex items-center"
                @click="paginateTo(previousPage)"
            >
                <svg-icon size="20" type="keyboard-arrow-left"/>
                <span class="hidden md:inline-block">
                    {{ $t('general.pagination.previous') }}
                </span>
            </button>

            <template v-for="page in pages">
                <span
                    v-if="isDot(page)"
                    class="text-primary-40 pointer-events-none"
                >
                    {{ page }}
                </span>
                <button
                    v-else
                    :class="[ isActive(page) ? 'z-10 font-semibold pointer-events-none' : 'cursor-pointer' ]"
                    class="inline-flex text-black"
                    @click="paginateTo(page)"
                >
                    {{ page }}
                </button>
            </template>
            <button
                :class="[!hasNext ? 'z-10 text-primary-60 pointer-events-none' : 'text-black cursor-pointer']"
                class="flex items-center"
                @click="paginateTo(nextPage)"
            >
                <span class="hidden md:inline-block">
                    {{ $t('general.pagination.next') }}
                </span>
                <svg-icon size="20" type="keyboard-arrow-right"/>
            </button>
        </nav>
    </div>
</template>

<script>
import SvgIcon from '../ui/SvgIcon.vue';

export default {
    components: {SvgIcon},
    props: {
        data: {
            // laravel pagination data object
            type: Object,
            required: true,
        },
        onEachSide: {
            // number of pages each side of current page
            type: Number,
            default: 3,
        },
        hideTotals: Boolean,
        dots: {
            // dots of hidden numbers
            type: String,
            default: '...',
        },
        disableUpdateUrl: Boolean,
        autoHidePaginate: {
            // auto hide paginate if has not more then one page
            type: Boolean,
            default: true,
        },
    },
    computed: {
        showPaginate() {
            // When not have data hide paginate
            if (!this.data.data) {
                return false;
            }
            // if total page = 1. then depends on user props value
            return this.totalPage === 1 ? !this.autoHidePaginate : true;
        },
        hasPrevious() {
            // has previous page
            return this.currentPage > 1;
        },
        previousPage() {
            // previous page
            return this.currentPage - 1;
        },
        currentPage() {
            // current page
            return parseInt(this.data.meta.current_page);
        },
        nextPage() {
            // next page number
            return this.currentPage + 1;
        },
        hasNext() {
            // has next page
            return this.nextPage <= this.totalPage;
        },
        totalPage() {
            // total pages
            return this.data.meta.last_page;
        },
        pages() {
            // When less
            if (this.onEachSide <= -1) {
                return this.totalPage;
            }
            // pages
            let pages = [];
            for (let i = 1; i <= this.totalPage; i++) {
                if (i === this.currentPage || i === 1 || i === this.totalPage || (i >= (this.currentPage - this.onEachSide) && i <= (this.currentPage + this.onEachSide))) {
                    pages.push(i);
                } else if (pages[pages.length - 1] !== this.dots) {
                    pages.push(this.dots);
                }
            }
            return pages;
        },
    },
    methods: {
        isActive(pageNumber) {
            // is active
            return pageNumber === this.currentPage;
        },
        isDot(content) {
            return content === this.dots ? true : false;
        },
        paginateTo(pageNumber) {
            // if page number is not valid
            if (pageNumber < 1 || pageNumber > this.totalPage) {
                return;
            }

            // Set router
            if(!this.disableUpdateUrl){
                this.$router.push({query: {page: pageNumber}});
            }

            // goto page
            this.$emit('paginateTo', pageNumber);
        },
    },
};
</script>
